module.exports = __webpack_public_path__ + "tv.svg?dad64b28f3267a68f57c07541416a485";